// extracted by mini-css-extract-plugin
export default {"inputForm":"Input_inputForm__HYya4","customInput":"Input_customInput__QNoox","customLabel":"Input_customLabel__GtVPH"};